import React, { useState } from 'react';

import { GetAffiliateStatisticsResponse } from '../../../Api/CRM/Responses/AffiliateStatisticsResponse';
import DateSelect from '../../elements/DateSelect';
import Card from '../../elements/common/Card';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';

function SubAffiliateStatistics({ url }: { url: string }) {
    const [data, setData] = useState<GetAffiliateStatisticsResponse>({} as GetAffiliateStatisticsResponse);

    return (
        <Card title="Sub Affiliate statistics">
            <DateSelect
                url={`${url}/stats`}
                setData={setData}
                defaultRange={undefined}
                defaultStartDate={undefined}
                defaultEndDate={undefined}
                setStartDay={undefined}
                setEndDay={undefined}
                setIsLoading={undefined}
            />
            <TableDetailsBody>
                <Row label="Tickets">{data.ticketsCount}</Row>
                <Row label="Tickets sum">{data.ticketsSum}</Row>
                <Row label="FTD">{data.ftd}</Row>
                <Row label="STD">{data.std}</Row>
                <Row label="STP">{data.stp}</Row>
                <Row label="Deposits">{data.allDepositsCount}</Row>
                <Row label="Confirmed deposits">{data.confirmedDepositsCount}</Row>
                <Row label="Not confirmed deposits">{data.depositsNotConfirmedCount}</Row>
                <Row label="Deposit sum">{data.depositsSum}</Row>
                <Row label="Register count">{data.registerCount}</Row>
                <Row label="Average user value">{data.avgUserValue}</Row>
                <Row label="Average returning user value">{data.avgReturningUserValue}</Row>
                <Row label="Affiliate earning">{data.earning}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default SubAffiliateStatistics;
